// Utilidades para manejar el logout de manera robusta

// Función para verificar si el logout es intencional
export const isIntentionalLogout = () => {
  return localStorage.getItem("intentionalLogout") === "true";
};

// Función para marcar logout intencional
export const markIntentionalLogout = () => {
  localStorage.setItem("intentionalLogout", "true");
  // console.log("Logout intencional marcado");
};

// Función para limpiar logout intencional
export const clearIntentionalLogout = () => {
  localStorage.removeItem("intentionalLogout");
  // console.log("Logout intencional limpiado");
};

// Función para verificar si se debe mostrar alerta de sesión expirada
export const shouldShowSessionExpiredAlert = () => {
  // console.log("isIntentionalLogout", isIntentionalLogout());
  // No mostrar alerta si es logout intencional
  if (isIntentionalLogout()) {
    return false;
  }

  // No mostrar alerta si no hay token
  const hasToken =
    localStorage.getItem("token") || localStorage.getItem("accessToken");
  if (!hasToken) {
    return false;
  }

  // No mostrar alerta si ya se mostró
  if (localStorage.getItem("sessionExpiredAlertShown")) {
    return false;
  }

  return true;
};

// Función para limpiar todas las banderas de logout
export const clearAllLogoutFlags = () => {
  localStorage.removeItem("intentionalLogout");
  localStorage.removeItem("sessionExpiredAlertShown");
  // console.log("Todas las banderas de logout han sido limpiadas");
};
